import React, { MouseEventHandler } from 'react';
import { Button } from 'react-bootstrap';

interface ButtonConfig {
  func?: MouseEventHandler<HTMLButtonElement>;
  label?: string;
  bsPrefix?: string;
  variant?: string;
  disabled?: boolean;
  props?: object;
}

export const buildButton = ({
  func,
  label,
  bsPrefix,
  variant = 'primary',
  disabled = false,
  props,
}: ButtonConfig = {}) => {
  if (!func) return null;
  return (
    <Button {...props} onClick={func} bsPrefix={bsPrefix} variant={variant} disabled={disabled}>
      {label}
    </Button>
  );
};
